import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Suppress benign ResizeObserver errors that don't affect functionality
// This is a known browser limitation, not an actual bug
const isResizeObserverError = (message) => {
  if (!message) return false;
  return (
    message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded') ||
    message.includes('ResizeObserver')
  );
};

// Override console.error to suppress ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args[0]?.toString?.() || '';
  if (isResizeObserverError(message)) {
    return; // Suppress the error
  }
  originalConsoleError.apply(console, args);
};

// Global error handler to catch ResizeObserver errors before React's error overlay
window.addEventListener('error', (e) => {
  if (isResizeObserverError(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
}, true); // Use capture phase to catch before React

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (e) => {
  if (isResizeObserverError(e.reason?.message || e.reason?.toString?.())) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✓ Service Worker registered:', registration);
      })
      .catch((error) => {
        console.log('✗ Service Worker registration failed:', error);
      });
  });
}
